import {
  CUSTOMER_ORDER_ACTIVE_STATUS_VALUES,
  type OrderStatus,
} from '../../types/order';

// UI-only progress rail for customer orders. Backend remains the source of
// truth for allowed transitions; this array only defines detail-page order.
export const CUSTOMER_ORDER_PROGRESS_STATUSES: OrderStatus[] =
  CUSTOMER_ORDER_ACTIVE_STATUS_VALUES.filter(
    (status) => status !== 'ON_HOLD' && status !== 'CANCELLED',
  );

export const getCustomerOrderProgressStatuses = (
  _currentStatus: OrderStatus,
  _statusHistory: Array<{ status?: string | null }> = [],
): OrderStatus[] => CUSTOMER_ORDER_PROGRESS_STATUSES;

// UX mirror of backend customerOrderStatusPolicy.startsCustomerOrderConfirmationCycle
// (WP4 / decision 2026-10-04): leaving Szkic / Oferta wysłana / Anulowane for
// a status that takes part in the stock allocation starts a confirmation
// cycle — the moment the backend writes the draft ZD and sends the notices.
// The backend decides; this only shows the confirmation section in the dialog.
const CONFIRMATION_QUEUE_RESET_STATUSES: readonly string[] = ['NEW_INQUIRY', 'QUOTE_SENT', 'CANCELLED'];
const NON_ALLOCATING_STATUSES: readonly string[] = [...CONFIRMATION_QUEUE_RESET_STATUSES, 'INVOICED'];

export const startsCustomerOrderConfirmationCycle = (
  previousStatus: string | null | undefined,
  nextStatus: string | null | undefined,
): boolean => Boolean(
  previousStatus
  && nextStatus
  && CONFIRMATION_QUEUE_RESET_STATUSES.includes(previousStatus)
  && (CUSTOMER_ORDER_ACTIVE_STATUS_VALUES as readonly string[]).includes(nextStatus)
  && !NON_ALLOCATING_STATUSES.includes(nextStatus),
);
